export default __webpack_public_path__ + "static/media/B2.c63648de.png";